// The old dashboard's language filter, one rule so the three pages that carry
// it cannot drift apart.
//
// It offered exactly two choices — Bilingual and English only — and this
// organization has exactly two routing languages, English and Spanish, so
// "Bilingual" meant "also speaks Spanish". Both are kept by name, and every
// language Genesys actually holds is offered beside them, which is the part
// the old app could not do.
//
// An agent Genesys names NO language for passes every filter. That is the old
// app's rule and it is the right one: an empty list is "not recorded", not
// "English", and filtering someone off the floor on a blank field is how a
// Spanish speaker stops being findable when a Spanish queue backs up.

export const LANGUAGE_MODES = ['Bilingual', 'English only'];

/** Every language on this floor, in order, after the two named modes. */
export function languageOptions(agents) {
  const seen = new Set();
  for (const a of agents || []) for (const l of a.languages || []) seen.add(l);
  return [...LANGUAGE_MODES, ...[...seen].sort()];
}

export function matchesLanguage(agent, choice) {
  if (!choice) return true;
  const langs = agent?.languages || [];
  if (!langs.length) return true;
  if (choice === 'Bilingual') return langs.includes('Spanish');
  if (choice === 'English only') return !langs.includes('Spanish');
  return langs.includes(choice);
}
